module.exports = __webpack_public_path__ + "static/media/asset-planet-background1.7f8a298c.jpeg";